webpackJsonp([48],{

/***/ 1098:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


function data() {
	return {
		filters: [{
			id: 1, value: 1, label: 'Día', days: 0
		}, {
			id: 2, value: 2, label: 'Semana', days: 7
		}, {
			id: 3, value: 3, label: 'Mes', days: 30
		}, {
			id: 4, value: 4, label: 'Año', days: 365
		}]
	};
}

function applyFilter(filter) {
	this.$emit('apply-filter', filter);
}

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'filters-by-time',
	data: data,
	props: {
		value: {
			type: Number,
			default: 1
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		applyFilter: applyFilter
	}
});

/***/ }),

/***/ 1103:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".filters-by-time[data-v-79facaf4]{color:#85939e;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;width:408px}.filters-by-time button.btn[data-v-79facaf4]{background-color:#fff!important;-webkit-box-shadow:0 2px 4px 0 rgba(0,0,0,.18);box-shadow:0 2px 4px 0 rgba(0,0,0,.18);color:#85939e;font-size:14px!important;height:40px;margin-left:14px;max-width:73px}.filters-by-time button.btn.active[data-v-79facaf4]{background-color:#29abe2!important;color:#fff}", "", {"version":3,"sources":["/opt/build/repo/src/components/shared/FiltersByTime.vue"],"names":[],"mappings":"AACA,kCACE,cAAe,AACf,2BAA4B,AAC5B,2BAA4B,AAC5B,oBAAqB,AACrB,WAAuB,CACxB,AACD,6CACI,gCAAmC,AACnC,+CAAoD,AAC5C,uCAA4C,AACpD,cAAe,AACf,yBAA2B,AAC3B,YAAa,AACb,iBAAkB,AAClB,cAAgB,CACnB,AACD,oDACM,mCAAqC,AACrC,UAAa,CAClB","file":"FiltersByTime.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.filters-by-time[data-v-79facaf4] {\n  color: #85939e;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  width: calc(102px * 4);\n}\n.filters-by-time button.btn[data-v-79facaf4] {\n    background-color: white !important;\n    -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);\n            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);\n    color: #85939e;\n    font-size: 14px !important;\n    height: 40px;\n    margin-left: 14px;\n    max-width: 73px;\n}\n.filters-by-time button.btn.active[data-v-79facaf4] {\n      background-color: #29abe2 !important;\n      color: white;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1104:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1103);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("6dcc94fc", content, true);

/***/ }),

/***/ 1105:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1104)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1098),
  /* template */
  __webpack_require__(1106),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-79facaf4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1106:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "filters-by-time"
  }, _vm._l((_vm.filters), function(filter) {
    return _c('v-btn', {
      key: filter.id,
      class: {
        'active': filter.id === _vm.value
      },
      attrs: {
        "disabled": _vm.loading
      },
      on: {
        "click": function($event) {
          _vm.applyFilter(filter)
        }
      }
    }, [_vm._v("\n\t\t" + _vm._s(filter.label) + "\n\t")])
  }))
},staticRenderFns: []}

/***/ }),

/***/ 1344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_FiltersByTime__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_shared_FiltersByTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_shared_FiltersByTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_TabsComponent__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_TabsComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_shared_TabsComponent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_RoomStatus__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_shared_RoomStatus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_shared_RoomStatus__);






var editRoomStates = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _this3 = this;

		var newRoomsSelected;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						newRoomsSelected = this.roomsSelected.map(function (room) {
							var newRoom = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, room);
							newRoom.hk_ms_statehk_room_id = _this3.stateSelectedId;
							return newRoom;
						}, this);
						_context.next = 3;
						return this.$http.post('room-update-multiple', newRoomsSelected);

					case 3:
						this.showNotification('Los cambios fueron guardados satisfactoriamente', 'success');
						this.dialog = false;
						this.loadData();
						this.roomsSelected = [];
						this.stateSelected = null;
						this.stateSelectedId = null;
						this.statusTypes = this.statusTypes.map(function (status) {
							var newStatus = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, status);
							newStatus.isSelected = false;
							newStatus.isAdded = false;
							return newStatus;
						});

					case 10:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function editRoomStates() {
		return _ref.apply(this, arguments);
	};
}();

var loadBuildings = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(id) {
		var filterGroups, filterBySubsidiaries, filterBySubsidiariesId, request, responses;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						filterGroups = [];
						filterBySubsidiaries = [];

						if (id) {
							this.filterBySubsidiaryId = this.renderFilter('com_subsidiary_id', id, 'eq');
							filterBySubsidiariesId = this.renderFilter('com_subsidiaries_id', id, 'eq');

							filterGroups.push(this.filterBySubsidiaryId);
							filterBySubsidiaries.push(filterBySubsidiariesId);
						} else {
							this.filterBySubsidiaryId = null;
						}
						this.filterByRoomId = null;
						this.filterByBuildingId = null;
						this.buildingId = 0;
						this.roomId = 0;
						request = [this.$http.get('building-simple-list', { params: { filter_groups: filterBySubsidiaries } }), this.$http.get('roomtype-simple-list', { params: { filter_groups: filterBySubsidiaries } })];
						_context2.next = 10;
						return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(request);

					case 10:
						responses = _context2.sent;

						this.buildings = responses[0].data;
						this.rooms = responses[1].data;
						this.loadData();

					case 14:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function loadBuildings(_x) {
		return _ref2.apply(this, arguments);
	};
}();

var loadData = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var _this4 = this;

		var filterGroups, response;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						filterGroups = [];

						if (this.filterBySubsidiaryId) {
							filterGroups.push(this.filterBySubsidiaryId);
						}
						if (this.filterByBuildingId) {
							filterGroups.push(this.filterByBuildingId);
						}
						if (this.filterByRoomId) {
							filterGroups.push(this.filterByRoomId);
						}
						if (this.filterByDate) {
							filterGroups.push(this.filterByDate);
						}
						if (this.filterByTypeId) {
							filterGroups.push(this.filterByTypeId);
						}
						if (this.filterByCleanTypeId) {
							filterGroups.push(this.filterByCleanTypeId);
						}
						_context3.next = 9;
						return this.$http.get('dashboard', { params: { filter_groups: filterGroups } });

					case 9:
						response = _context3.sent;

						if (this.isMounted) {
							this.statusTypes.push({ id: 0, name: 'All' });
							response.data.room_states.forEach(function (state) {
								var newState = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, state);
								newState.isSelected = false;
								newState.isAdded = false;
								_this4.statusTypes.push(newState);
							});
							this.roomCleaningTypes.push({ id: 0, name: 'All' });
							response.data.type_cleaning_list.forEach(function (clean) {
								_this4.roomCleaningTypes.push(clean);
							});
						}
						__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.data.states).forEach(function (key) {
							response.data.states[key].rooms = response.data.states[key].rooms.map(function (room) {
								var newRoom = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, room);
								newRoom.isAdded = false;
								newRoom.isSelected = false;
								return newRoom;
							});
						});
						this.states = response.data.states;
						this.housemaids = response.data.housemaids;
						this.summaryStates = response.data.maid_states_quantity;
						this.summaryAlerts = response.data.maid_alerts_quantity.map(function (alert) {
							var newAlert = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, alert);
							if (alert.code_alert === 'OP') {
								newAlert.routerName = 'lostandfound';
							} else if (alert.code_alert === 'RP') {
								newAlert.routerName = 'problem-report';
							} else {
								newAlert.routerName = 'maintenance-container';
							}
							return newAlert;
						});
						this.isMounted = false;

					case 17:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this);
	}));

	return function loadData() {
		return _ref3.apply(this, arguments);
	};
}();

var onDateFilter = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(_ref5) {
		var value = _ref5.value,
		    days = _ref5.days;
		var newDate, dateToString;
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						newDate = new Date(this.endDate);

						if (days >= 0) {
							dateToString = newDate.setDate(newDate.getDate() - days);

							this.startDate = new Date(dateToString).toISOString().substr(0, 10);
						}
						if (value) {
							this.value = value;
						} else {
							this.value = 0;
						}
						this.loading = true;
						this.filterByDate = this.renderFilter('date_clear', [this.startDate, this.endDate], 'bt');
						this.loadData();
						this.loading = false;

					case 7:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this);
	}));

	return function onDateFilter(_x2) {
		return _ref4.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var date = new Date();

var currentDate = {
	day: date.getDate(),
	month: date.getMonth() < 9 ? '0' + date.getMonth() : date.getMonth() + 1,
	today: date.toISOString().substr(0, 10),
	value: date,
	year: date.getFullYear()
};

function created() {
	this.loadData();
	this.loadSubsidiaries();
	this.isMounted = true;
}

function cancelEdit() {
	var _this = this;

	this.roomsSelected.forEach(function (roomSelected) {
		_this.states[roomSelected.code_state].rooms = _this.states[roomSelected.code_state].rooms.map(function (room) {
			var newRoom = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, room);
			if (roomSelected.id === room.id) {
				newRoom.isAdded = false;
				newRoom.isSelected = false;
			}
			return newRoom;
		});
	}, this);
	this.roomsSelected = [];
}

function changeIcon(result) {
	this.onChange = result;
}

function changeEndIcon(result) {
	this.onChangeEnd = result;
}

function changeFormatDate(value) {
	return new Date(value).toISOString().substr(0, 10);
}

function deleteRoomAdded(id) {
	var _this2 = this;

	var index = this.roomsSelected.findIndex(function (roomSelected) {
		return roomSelected.id === id;
	});
	this.roomsSelected.forEach(function (roomSelected) {
		_this2.states[roomSelected.code_state].rooms = _this2.states[roomSelected.code_state].rooms.map(function (room) {
			var newRoom = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, room);
			if (room.id === id) {
				newRoom.isAdded = false;
				newRoom.isSelected = false;
			}
			return newRoom;
		});
	}, this);
	if (index || index === 0) {
		this.roomsSelected.splice(index, 1);
	}
}

function filterById(id) {
	this.filterByRoomId = this.renderFilter('hot_ms_roomtype_id', id, 'eq');
	this.loadData();
}

function filterType(id) {
	if (id) {
		this.filterByTypeId = this.renderFilter('com_ms_type_cleaning_id', id, 'eq');
	} else {
		this.filterByTypeId = null;
		this.roomTypeId = 0;
	}
	this.loadData();
}

function filterStatusType(id) {
	if (id) {
		this.filterByCleanTypeId = this.renderFilter('hk_ms_statehk_room_id', id, 'eq');
	} else {
		this.filterByCleanTypeId = null;
		this.statusTypeId = 0;
	}
	this.loadData();
}

function loadRooms(id) {
	this.filterByBuildingId = this.renderFilter('hot_building_id', id, 'eq');
	this.loadData();
}

function roomIsSelected(room) {
	if (room.isSelected) {
		this.roomsSelected.push(room);
	} else {
		var index = this.roomsSelected.findIndex(function (roomSelected) {
			return roomSelected.id === room.id;
		});
		this.roomsSelected.splice(index, 1);
	}
}

function stateToChange(room) {
	var _this5 = this;

	this.statusTypes = this.statusTypes.map(function (status) {
		var newStatus = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, status);
		if (status.id === _this5.stateSelectedId) {
			newStatus.isSelected = false;
			newStatus.isAdded = false;
		}
		return newStatus;
	}, this);
	this.stateSelected = room;
	this.stateSelectedId = room.id;
}

function toggleIconStartDate() {
	this.onChange = !this.startDate;
}

function toggleIconEndDate() {
	this.onChange = !this.endDate;
}

function arrowIconEnd() {
	var arrow = this.onChangeEnd ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

function arrowIconStart() {
	var arrow = this.onChange ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrow;
}

/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		FiltersByTime: __WEBPACK_IMPORTED_MODULE_6__components_shared_FiltersByTime___default.a,
		RoomStatus: __WEBPACK_IMPORTED_MODULE_8__components_shared_RoomStatus___default.a,
		TabsComponent: __WEBPACK_IMPORTED_MODULE_7__components_shared_TabsComponent___default.a
	},
	computed: {
		arrowIconEnd: arrowIconEnd,
		arrowIconStart: arrowIconStart
	},
	created: created,
	data: function data() {
		return {
			breakHref: {
				name: 'break'
			},
			buildings: [],
			buildingId: 0,
			dialog: false,
			endDate: currentDate.today,
			filterByBuildingId: null,
			filterByCleanTypeId: null,
			filterByDate: null,
			filterByRoomId: null,
			filterBySubsidiaryId: null,
			filterByTypeId: null,
			formatted: null,
			highPerformanceHref: {
				name: 'high-performance'
			},
			isMounted: false,
			loading: false,
			lowPerformanceHref: {
				name: 'low-performance'
			},
			housemaids: [],
			menu: false,
			menuEnd: false,
			onChange: false,
			onChangeEnd: false,
			roomId: 0,
			rooms: [],
			roomsSelected: [],
			roomCleaningTypes: [],
			roomTypeId: 0,
			startDate: currentDate.today,
			stateSelected: null,
			stateSelectedId: null,
			statusTypes: [],
			statusTypeId: 0,
			states: [],
			subsidiaryId: 0,
			summaryAlerts: [],
			summaryStates: [],
			tabs: [{
				id: 1,
				title: 'Trabajadores',
				link: '/dashboard'
			}, {
				id: 2,
				title: 'Ventas',
				link: '/dashboard/sales'
			}],
			value: 0
		};
	},

	methods: {
		cancelEdit: cancelEdit,
		changeEndIcon: changeEndIcon,
		changeFormatDate: changeFormatDate,
		changeIcon: changeIcon,
		deleteRoomAdded: deleteRoomAdded,
		editRoomStates: editRoomStates,
		filterById: filterById,
		filterStatusType: filterStatusType,
		filterType: filterType,
		loadBuildings: loadBuildings,
		loadData: loadData,
		loadRooms: loadRooms,
		onDateFilter: onDateFilter,
		roomIsSelected: roomIsSelected,
		stateToChange: stateToChange,
		toggleIconEndDate: toggleIconEndDate,
		toggleIconStartDate: toggleIconStartDate
	},
	mixins: __WEBPACK_IMPORTED_MODULE_5__shared_mixins__["a" /* default */],
	name: 'main-dashboard'
});

/***/ }),

/***/ 1410:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(772)(true);
// imports


// module
exports.push([module.i, ".start-date-select label[data-v-6672461e]{margin:-14px 0 0 25%}.button-default[data-v-6672461e]{margin-bottom:12px;margin-top:0}.oval-select.input-group[data-v-6672461e]{border:2px solid #8f9093;border-radius:100px;-webkit-box-shadow:none;box-shadow:none;height:23px;max-width:-webkit-fit-content;max-width:-moz-fit-content;max-width:fit-content;min-height:23px;min-width:125px}.label-status[data-v-6672461e]{background-color:#dcdcdc;-webkit-box-flex:0;-ms-flex:none;flex:none;height:26px;margin-bottom:15px;padding:0 20px 0 11px;width:100%}.label-status h5[data-v-6672461e]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font-size:12px;margin:-2px 0 0}.label-status h5 a[data-v-6672461e]{color:#6f7a83}.label-status h5[data-v-6672461e]:first-child{float:left}.label-status h5[data-v-6672461e]:nth-child(2){float:right}.divider-rows .divider1[data-v-6672461e]{border-right:1px solid #d8d8d8;padding-right:1%}.divider-rows .divider2[data-v-6672461e]{padding-left:1%}.divider-rows .divider2 .alerts[data-v-6672461e]{border-top:1px solid #d8d8d8;margin-top:2%}.divider-rows .divider2>.layout[data-v-6672461e]:first-child{height:29px}.divider-rows .divider2>.layout:nth-child(3) h5[data-v-6672461e]{margin-bottom:0;margin-top:16px}.divider-rows .divider2 .b-alerts[data-v-6672461e]{border-bottom:1px solid #d8d8d8;padding-bottom:4%;padding-left:2%}.summary[data-v-6672461e]{background-color:#fff;border:5px solid;border-radius:60px;height:92px;margin:0 28px 10px;text-align:center;width:92px}.summary-container[data-v-6672461e]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.summary-container p[data-v-6672461e]{font-size:48px;margin:5px}.summary-container a[data-v-6672461e],.summary-container a[data-v-6672461e]:active,.summary-container a[data-v-6672461e]:focus,.summary-container a[data-v-6672461e]:hover{color:#6f7a83;font-size:12px;text-decoration:none}.oval-button[data-v-6672461e]{background-color:#353c4c;border-radius:100px;color:#fff;font-family:San Francisco Display Semi Bold;font-size:12px;height:23px;line-height:21px;min-width:64px}.oval-button[disabled][data-v-6672461e]{background-color:transparent;border:2px solid #8f9093;color:#8f9093}.oval-button.cancel[data-v-6672461e]{background-color:#e2525c}.report-maid[data-v-6672461e]{border-bottom:1px solid transparent;padding:0 20px 0 10px}.report-maid a[data-v-6672461e],.report-maid span[data-v-6672461e]{color:#000;font-size:14px;margin:0;vertical-align:middle}.report-maid[data-v-6672461e]:hover{border-bottom:1px solid #29abe2;cursor:pointer}.report-maid:hover a[data-v-6672461e],.report-maid:hover span[data-v-6672461e]{font-family:San Francisco Display Medium;font-size:14px}.realtime-content[data-v-6672461e]{background-color:#fff;margin-bottom:28px;margin-left:8px;padding:14px 10px;width:100%}.realtime-content .realtime-item[data-v-6672461e]{border-bottom:1px solid #d8d8d8;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;margin-bottom:12.5px;text-align:left}.realtime-content .realtime-item img[data-v-6672461e]{border-radius:50px;height:46px;width:46px}.realtime-content .realtime-item h5[data-v-6672461e]{font-size:14px;line-height:18px;margin-bottom:11px}.realtime-content .realtime-item h6[data-v-6672461e]{font-size:12px}.realtime-content .little-icon[data-v-6672461e]{-ms-flex-line-pack:center;align-content:center}.realtime-blue[data-v-6672461e]{color:#29abe2}.realtime-gray[data-v-6672461e]{color:#818181}.realtime-green[data-v-6672461e]{color:#00ca52}.realtime-red[data-v-6672461e]{color:#f23f3f}.score-ball[data-v-6672461e]{border-radius:100%;display:inline-block;height:14px;vertical-align:middle;width:14px}.rt-calendar[data-v-6672461e]{border-radius:20px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;height:17px;margin-right:6px;width:17px}.rt-calendar.blue[data-v-6672461e]{background-color:#09ceff!important;background-image:url(/static/img/sprites/spritesheet-icons.png);background-position:-38px -23px}.rt-calendar.red[data-v-6672461e]{background-color:#f23f3f!important;background-image:url(/static/img/sprites/spritesheet-icons.png);background-position:-26px -1px}.rt-calendar+h6[data-v-6672461e]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;vertical-align:super}.modal-dashboard .headline[data-v-6672461e]{color:#353c4c;font-family:San Francisco Display Medium;font-size:20px!important;padding-bottom:0}.modal-dashboard .headline i[data-v-6672461e]{color:#303645;cursor:pointer;position:absolute;right:10px;top:10px}.modal-dashboard .subtitle[data-v-6672461e]{color:#353c4c;font-family:San Francisco Display Medium;font-size:14px;margin:0}", "", {"version":3,"sources":["/opt/build/repo/src/housekeeping/dashboard/Dashboard.vue"],"names":[],"mappings":"AACA,0CACE,oBAA0B,CAC3B,AACD,iCACE,mBAAoB,AACpB,YAAc,CACf,AACD,0CACE,yBAA0B,AAC1B,oBAAqB,AACrB,wBAAyB,AACjB,gBAAiB,AACzB,YAAa,AACb,8BAA+B,AAC/B,2BAA4B,AAC5B,sBAAuB,AACvB,gBAAiB,AACjB,eAAiB,CAClB,AACD,+BACE,yBAA0B,AAC1B,mBAAoB,AAChB,cAAe,AACX,UAAW,AACnB,YAAa,AACb,mBAAoB,AACpB,sBAAuB,AACvB,UAAY,CACb,AACD,kCACI,2BAA4B,AAC5B,2BAA4B,AAC5B,oBAAqB,AACrB,eAAgB,AAChB,eAAmB,CACtB,AACD,oCACM,aAAe,CACpB,AACD,8CACM,UAAY,CACjB,AACD,+CACM,WAAa,CAClB,AACD,yCACE,+BAAgC,AAChC,gBAAkB,CACnB,AACD,yCACE,eAAiB,CAClB,AACD,iDACI,6BAA8B,AAC9B,aAAe,CAClB,AACD,6DACI,WAAa,CAChB,AACD,iEACI,gBAAiB,AACjB,eAAiB,CACpB,AACD,mDACI,gCAAiC,AACjC,kBAAmB,AACnB,eAAiB,CACpB,AACD,0BACE,sBAA0B,AAC1B,iBAAkB,AAClB,mBAAoB,AACpB,YAAa,AACb,mBAAoB,AACpB,kBAAmB,AACnB,UAAY,CACb,AACD,oCACI,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACnC,AACD,sCACM,eAAgB,AAChB,UAAY,CACjB,AACD,2KAIM,cAAe,AACf,eAAgB,AAChB,oBAAsB,CAC3B,AACD,8BACE,yBAA0B,AAC1B,oBAAqB,AACrB,WAAa,AACb,4CAA+C,AAC/C,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,cAAgB,CACjB,AACD,wCACI,6BAA8B,AAC9B,yBAA0B,AAC1B,aAAe,CAClB,AACD,qCACI,wBAA0B,CAC7B,AACD,8BACE,oCAAqC,AACrC,qBAAuB,CACxB,AACD,mEAEI,WAAa,AACb,eAAgB,AAChB,SAAU,AACV,qBAAuB,CAC1B,AACD,oCACI,gCAAiC,AACjC,cAAgB,CACnB,AACD,+EAEM,yCAA4C,AAC5C,cAAgB,CACrB,AACD,mCACE,sBAAwB,AACxB,mBAAoB,AACpB,gBAAiB,AACjB,kBAAmB,AACnB,UAAY,CACb,AACD,kDACI,gCAAiC,AACjC,2BAA4B,AAC5B,wBAAyB,AACzB,mBAAoB,AACpB,qBAAsB,AACtB,eAAiB,CACpB,AACD,sDACM,mBAAoB,AACpB,YAAa,AACb,UAAY,CACjB,AACD,qDACM,eAAgB,AAChB,iBAAkB,AAClB,kBAAoB,CACzB,AACD,qDACM,cAAgB,CACrB,AACD,gDACI,0BAA2B,AACvB,oBAAsB,CAC7B,AACD,gCACE,aAAe,CAChB,AACD,gCACE,aAAe,CAChB,AACD,iCACE,aAAe,CAChB,AACD,+BACE,aAAe,CAChB,AACD,6BACE,mBAAoB,AACpB,qBAAsB,AACtB,YAAa,AACb,sBAAuB,AACvB,UAAY,CACb,AACD,8BACE,mBAAoB,AACpB,2BAA4B,AAC5B,2BAA4B,AAC5B,oBAAqB,AACrB,YAAa,AACb,iBAAkB,AAClB,UAAY,CACb,AACD,mCACI,mCAAqC,AACrC,gEAAiE,AACjE,+BAAiC,CACpC,AACD,kCACI,mCAAqC,AACrC,gEAAiE,AACjE,8BAAgC,CACnC,AACD,iCACI,2BAA4B,AAC5B,2BAA4B,AAC5B,oBAAqB,AACrB,oBAAsB,CACzB,AACD,4CACE,cAAe,AACf,yCAA4C,AAC5C,yBAA2B,AAC3B,gBAAoB,CACrB,AACD,8CACI,cAAe,AACf,eAAgB,AAChB,kBAAmB,AACnB,WAAY,AACZ,QAAU,CACb,AACD,4CACE,cAAe,AACf,yCAA4C,AAC5C,eAAgB,AAChB,QAAY,CACb","file":"Dashboard.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.start-date-select label[data-v-6672461e] {\n  margin: -14px 0px 0px 25%;\n}\n.button-default[data-v-6672461e] {\n  margin-bottom: 12px;\n  margin-top: 0;\n}\n.oval-select.input-group[data-v-6672461e] {\n  border: 2px solid #8f9093;\n  border-radius: 100px;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  height: 23px;\n  max-width: -webkit-fit-content;\n  max-width: -moz-fit-content;\n  max-width: fit-content;\n  min-height: 23px;\n  min-width: 125px;\n}\n.label-status[data-v-6672461e] {\n  background-color: #dcdcdc;\n  -webkit-box-flex: 0;\n      -ms-flex: none;\n          flex: none;\n  height: 26px;\n  margin-bottom: 15px;\n  padding: 0 20px 0 11px;\n  width: 100%;\n}\n.label-status h5[data-v-6672461e] {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    font-size: 12px;\n    margin: -2px 0 0 0;\n}\n.label-status h5 a[data-v-6672461e] {\n      color: #6f7a83;\n}\n.label-status h5[data-v-6672461e]:first-child {\n      float: left;\n}\n.label-status h5[data-v-6672461e]:nth-child(2) {\n      float: right;\n}\n.divider-rows .divider1[data-v-6672461e] {\n  border-right: 1px solid #d8d8d8;\n  padding-right: 1%;\n}\n.divider-rows .divider2[data-v-6672461e] {\n  padding-left: 1%;\n}\n.divider-rows .divider2 .alerts[data-v-6672461e] {\n    border-top: 1px solid #d8d8d8;\n    margin-top: 2%;\n}\n.divider-rows .divider2 > .layout[data-v-6672461e]:first-child {\n    height: 29px;\n}\n.divider-rows .divider2 > .layout:nth-child(3) h5[data-v-6672461e] {\n    margin-bottom: 0;\n    margin-top: 16px;\n}\n.divider-rows .divider2 .b-alerts[data-v-6672461e] {\n    border-bottom: 1px solid #d8d8d8;\n    padding-bottom: 4%;\n    padding-left: 2%;\n}\n.summary[data-v-6672461e] {\n  background-color: #ffffff;\n  border: 5px solid;\n  border-radius: 60px;\n  height: 92px;\n  margin: 0 28px 10px;\n  text-align: center;\n  width: 92px;\n}\n.summary-container[data-v-6672461e] {\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.summary-container p[data-v-6672461e] {\n      font-size: 48px;\n      margin: 5px;\n}\n.summary-container a[data-v-6672461e],\n    .summary-container a[data-v-6672461e]:hover,\n    .summary-container a[data-v-6672461e]:focus,\n    .summary-container a[data-v-6672461e]:active {\n      color: #6f7a83;\n      font-size: 12px;\n      text-decoration: none;\n}\n.oval-button[data-v-6672461e] {\n  background-color: #353c4c;\n  border-radius: 100px;\n  color: white;\n  font-family: \"San Francisco Display Semi Bold\";\n  font-size: 12px;\n  height: 23px;\n  line-height: 21px;\n  min-width: 64px;\n}\n.oval-button[disabled][data-v-6672461e] {\n    background-color: transparent;\n    border: 2px solid #8f9093;\n    color: #8f9093;\n}\n.oval-button.cancel[data-v-6672461e] {\n    background-color: #e2525c;\n}\n.report-maid[data-v-6672461e] {\n  border-bottom: 1px solid transparent;\n  padding: 0 20px 0 10px;\n}\n.report-maid a[data-v-6672461e],\n  .report-maid span[data-v-6672461e] {\n    color: black;\n    font-size: 14px;\n    margin: 0;\n    vertical-align: middle;\n}\n.report-maid[data-v-6672461e]:hover {\n    border-bottom: 1px solid #29abe2;\n    cursor: pointer;\n}\n.report-maid:hover a[data-v-6672461e],\n    .report-maid:hover span[data-v-6672461e] {\n      font-family: \"San Francisco Display Medium\";\n      font-size: 14px;\n}\n.realtime-content[data-v-6672461e] {\n  background-color: white;\n  margin-bottom: 28px;\n  margin-left: 8px;\n  padding: 14px 10px;\n  width: 100%;\n}\n.realtime-content .realtime-item[data-v-6672461e] {\n    border-bottom: 1px solid #d8d8d8;\n    height: -webkit-fit-content;\n    height: -moz-fit-content;\n    height: fit-content;\n    margin-bottom: 12.5px;\n    text-align: left;\n}\n.realtime-content .realtime-item img[data-v-6672461e] {\n      border-radius: 50px;\n      height: 46px;\n      width: 46px;\n}\n.realtime-content .realtime-item h5[data-v-6672461e] {\n      font-size: 14px;\n      line-height: 18px;\n      margin-bottom: 11px;\n}\n.realtime-content .realtime-item h6[data-v-6672461e] {\n      font-size: 12px;\n}\n.realtime-content .little-icon[data-v-6672461e] {\n    -ms-flex-line-pack: center;\n        align-content: center;\n}\n.realtime-blue[data-v-6672461e] {\n  color: #29abe2;\n}\n.realtime-gray[data-v-6672461e] {\n  color: #818181;\n}\n.realtime-green[data-v-6672461e] {\n  color: #00ca52;\n}\n.realtime-red[data-v-6672461e] {\n  color: #f23f3f;\n}\n.score-ball[data-v-6672461e] {\n  border-radius: 100%;\n  display: inline-block;\n  height: 14px;\n  vertical-align: middle;\n  width: 14px;\n}\n.rt-calendar[data-v-6672461e] {\n  border-radius: 20px;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  height: 17px;\n  margin-right: 6px;\n  width: 17px;\n}\n.rt-calendar.blue[data-v-6672461e] {\n    background-color: #09ceff !important;\n    background-image: url(/static/img/sprites/spritesheet-icons.png);\n    background-position: -38px -23px;\n}\n.rt-calendar.red[data-v-6672461e] {\n    background-color: #f23f3f !important;\n    background-image: url(/static/img/sprites/spritesheet-icons.png);\n    background-position: -26px -1px;\n}\n.rt-calendar + h6[data-v-6672461e] {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    vertical-align: super;\n}\n.modal-dashboard .headline[data-v-6672461e] {\n  color: #353c4c;\n  font-family: \"San Francisco Display Medium\";\n  font-size: 20px !important;\n  padding-bottom: 0px;\n}\n.modal-dashboard .headline i[data-v-6672461e] {\n    color: #303645;\n    cursor: pointer;\n    position: absolute;\n    right: 10px;\n    top: 10px;\n}\n.modal-dashboard .subtitle[data-v-6672461e] {\n  color: #353c4c;\n  font-family: \"San Francisco Display Medium\";\n  font-size: 14px;\n  margin: 0px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1495:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1410);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(773)("a6dc27e2", content, true);

/***/ }),

/***/ 1655:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', [(_vm.$route.name === 'main-dashboard') ? _c('tabs-component', {
    attrs: {
      "tabs": _vm.tabs
    }
  }) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": "",
      "pt-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.subsidiaries,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "label": "Sucursal",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": _vm.loadBuildings
    },
    model: {
      value: (_vm.subsidiaryId),
      callback: function($$v) {
        _vm.subsidiaryId = $$v
      },
      expression: "subsidiaryId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.buildings,
      "disabled": _vm.buildings.length === 0,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "label": "Edificio",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": _vm.loadRooms
    },
    model: {
      value: (_vm.buildingId),
      callback: function($$v) {
        _vm.buildingId = $$v
      },
      expression: "buildingId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.rooms,
      "item-text": "name",
      "item-value": "id",
      "disabled": _vm.rooms.length === 0,
      "hide-details": "",
      "label": "Todas las habitaciones",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": _vm.filterById
    },
    model: {
      value: (_vm.roomId),
      callback: function($$v) {
        _vm.roomId = $$v
      },
      expression: "roomId"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "body-border-bottom": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md4": "",
      "my-1": ""
    }
  }, [_c('v-layout', {
    staticClass: "calendar-range",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": "",
      "pa-0": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    on: {
      "input": _vm.changeIcon
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Picker in menu",
      "prepend-icon": "event",
      "append-icon": _vm.arrowIconStart,
      "append-icon-cb": _vm.toggleIconStartDate,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "date-format": _vm.changeFormatDate,
      "formatted-value": _vm.formatted,
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.onDateFilter
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "pa-0": ""
    }
  }, [_c('v-menu', {
    staticClass: "menu-date-picker",
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    on: {
      "input": _vm.changeEndIcon
    },
    model: {
      value: (_vm.menuEnd),
      callback: function($$v) {
        _vm.menuEnd = $$v
      },
      expression: "menuEnd"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Picker in menu",
      "append-icon": _vm.arrowIconEnd,
      "append-icon-cb": _vm.toggleIconEndDate,
      "single-line": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "es-PE",
      "date-format": _vm.changeFormatDate,
      "formatted-value": _vm.formatted,
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": _vm.onDateFilter
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md8": "",
      "my-1": "",
      "text-xs-right": ""
    }
  }, [_c('filters-by-time', {
    attrs: {
      "loading": _vm.loading,
      "value": _vm.value
    },
    on: {
      "apply-filter": _vm.onDateFilter
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "divider-rows",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "divider1",
    attrs: {
      "md6": "",
      "pt-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-items-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md2": ""
    }
  }, [_c('h5', {
    staticClass: "little-subtitle-default mb-0 mr-3"
  }, [_vm._v("Habitaciones")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": ""
    }
  }, [_c('v-select', {
    staticClass: "oval-select mr-2",
    attrs: {
      "items": _vm.roomCleaningTypes,
      "item-text": "name",
      "item-value": "id",
      "label": "Tipo de limpieza",
      "single-line": "",
      "hide-details": "",
      "bottom": ""
    },
    on: {
      "change": _vm.filterType
    },
    model: {
      value: (_vm.roomTypeId),
      callback: function($$v) {
        _vm.roomTypeId = $$v
      },
      expression: "roomTypeId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": ""
    }
  }, [_c('v-select', {
    staticClass: "oval-select",
    attrs: {
      "items": _vm.statusTypes,
      "item-text": "name",
      "item-value": "id",
      "label": "Tipo de estado",
      "single-line": "",
      "hide-details": "",
      "bottom": ""
    },
    on: {
      "change": _vm.filterStatusType
    },
    model: {
      value: (_vm.statusTypeId),
      callback: function($$v) {
        _vm.statusTypeId = $$v
      },
      expression: "statusTypeId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md4": "",
      "text-xs-right": ""
    }
  }, [(_vm.roomsSelected.length > 0) ? _c('button', {
    staticClass: "oval-button cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tCancelar\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "oval-button ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.roomsSelected.length === 0
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = true
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tEditar\n\t\t\t\t\t\t")])])], 1), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('v-layout', {
      key: state.id,
      staticClass: "text-xs-left",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "md12": ""
      }
    }, [_c('div', {
      staticClass: "label-status"
    }, [_c('h5', [_c('router-link', {
      attrs: {
        "to": ("/dashboard/state/1/" + (state.name))
      }
    }, [_vm._v(_vm._s(state.name))])], 1), _vm._v(" "), _c('h5', [_vm._v(_vm._s(state.rooms.length) + " habitaciones")])])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md12": ""
      }
    }, _vm._l((state.rooms), function(room) {
      return _c('room-status', {
        key: room.id,
        attrs: {
          "background-color": room.color_state,
          "clean-state": room.clean_state,
          "number": room.number,
          "code": room.code_roomtype,
          "status-icon-img": room.icon_url,
          "room": room,
          "label-for": ("room-" + (room.id)),
          "extra-state": room.extra_state,
          "show-circle": true,
          "name": room.name
        },
        on: {
          "on-room-selected": _vm.roomIsSelected
        }
      })
    }))], 1)
  })], 2), _vm._v(" "), _c('v-flex', {
    staticClass: "divider2",
    attrs: {
      "md6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pl-1": ""
    }
  }, [_c('h5', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Estados")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "summary-container",
    attrs: {
      "row": "",
      "wrap": "",
      "pl-1": ""
    }
  }, _vm._l((_vm.summaryStates), function(summaryState) {
    return _c('div', {
      key: summaryState.id
    }, [_c('div', {
      staticClass: "summary",
      style: (("border-color: " + (summaryState.color_state) + "; color: " + (summaryState.color_state) + ";"))
    }, [_c('p', [_vm._v(_vm._s(summaryState.quantity))])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'housemaids-by-state',
          params: {
            stateId: summaryState.id,
            stateName: summaryState.name_state
          }
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(summaryState.name_state) + "\n\t\t\t\t\t\t")])], 1)
  })), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pl-1": ""
    }
  }, [_c('h5', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Mucamas")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pl-1": ""
    }
  }, [_c('div', {
    staticClass: "label-status mb-1"
  }, [_c('h5', [_vm._v("Nombre")]), _vm._v(" "), _c('h5', [_vm._v("Habitación")]), _vm._v(" "), _c('h5', [_vm._v("Calificación")])])]), _vm._v(" "), _vm._l((_vm.housemaids), function(maid) {
    return _c('v-layout', {
      key: maid.id,
      staticClass: "report-maid pl-0 ml-1",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "md4": "",
        "text-xs-left": ""
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'housemaids-profile',
          params: {
            id: maid.id
          }
        }
      }
    }, [_vm._v(_vm._s(maid.name) + " " + _vm._s(maid.lastname))])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md4": ""
      }
    }, [_c('div', {
      staticClass: "score-ball",
      style: (("background-color: " + (maid.color_state)))
    })]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md4": "",
        "text-xs-right": ""
      }
    }, [_c('span', [_vm._v(_vm._s(maid.room_assigned))])])], 1)
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "alerts pl-1",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('h5', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Alertas")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "summary-container",
    attrs: {
      "row": "",
      "wrap": "",
      "pl-1": ""
    }
  }, _vm._l((_vm.summaryAlerts), function(summaryAlert) {
    return _c('div', {
      key: summaryAlert.id
    }, [_c('div', {
      staticClass: "summary",
      style: (("border-color: " + (summaryAlert.color_alert) + "; color: " + (summaryAlert.color_alert) + ";"))
    }, [_c('p', [_vm._v(_vm._s(summaryAlert.quantity))])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: summaryAlert.routerName
        }
      }
    }, [_vm._v(_vm._s(summaryAlert.name_alert))])], 1)
  })), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "pl-1": ""
    }
  }, [_c('h5', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Actividades - Real time")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('div', {
    staticClass: "realtime-content"
  }, [_c('v-layout', {
    staticClass: "realtime-item",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md1": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "https://randomuser.me/api/portraits/women/59.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md11": "",
      "pl-4": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('h5', [_vm._v("\n\t\t\t\t\t\t\t\t\t\tMaria Chiappe\n\t\t\t\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("cambió de estado")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-blue"
  }, [_vm._v("En curso")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("a")]), _vm._v(" "), _c('span', {
    staticClass: "realtime-blue"
  }, [_vm._v("Almuerzo")])])]), _vm._v(" "), _c('v-layout', {
    staticClass: "little-icon",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "rt-calendar red"
  }), _vm._v(" "), _c('h6', {
    staticClass: "mb-0"
  }, [_c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("Fecha:")]), _vm._v(" 24/03/2017\n\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "rt-calendar blue"
  }), _vm._v(" "), _c('h6', {
    staticClass: "mb-0"
  }, [_c('span', {
    staticClass: "realtime-gray"
  }, [_vm._v("Hora:")]), _vm._v(" 09:15:24 am\n\t\t\t\t\t\t\t\t\t\t")])])], 1)], 1)], 1)], 1)])], 2)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "685",
      "content-class": "modal-dashboard"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n\t\t\t\tCambiar de estado\n\t\t\t\t"), _c('v-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = false
      }
    }
  }, [_vm._v("cancel")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Habitaciones seleccionadas")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "mt-2": ""
    }
  }, _vm._l((_vm.roomsSelected), function(roomSelected) {
    return _c('room-status', {
      key: roomSelected.id,
      attrs: {
        "background-color": roomSelected.color_state,
        "clean-state": roomSelected.clean_state,
        "number": roomSelected.number,
        "code": roomSelected.code_roomtype,
        "status-icon-img": roomSelected.icon_url,
        "room": roomSelected,
        "label-for": ("room-selected-" + (roomSelected.id)),
        "extra-state": roomSelected.extra_state,
        "show-circle": true,
        "name": roomSelected.name,
        "is-added": roomSelected.isAdded,
        "room-id": roomSelected.id,
        "state-code": roomSelected.code_state
      },
      on: {
        "on-room-removed": _vm.deleteRoomAdded
      }
    })
  })), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Define el estado de las habitaciones")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "mt-2": ""
    }
  }, _vm._l((_vm.statusTypes), function(roomState) {
    return (roomState.id) ? _c('room-status', {
      key: roomState.id,
      attrs: {
        "background-color": roomState.color_state,
        "status-icon-img": roomState.icon_url,
        "name": roomState.code_state,
        "room": roomState,
        "label-for": ("room-state-" + (roomState.id)),
        "name-state": roomState.name
      },
      on: {
        "on-room-selected": _vm.stateToChange
      }
    }) : _vm._e()
  }))], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-save mr-3 mb-2",
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.editRoomStates
    }
  }, [_vm._v("\n\t\t\t\t\tGuardar\n\t\t\t\t")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1495)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1344),
  /* template */
  __webpack_require__(1655),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6672461e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 952:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(953), __esModule: true };

/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(955);
module.exports = __webpack_require__(18).Object.keys;


/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(39);
var core = __webpack_require__(18);
var fails = __webpack_require__(90);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(147);
var $keys = __webpack_require__(141);

__webpack_require__(954)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ })

});


// WEBPACK FOOTER //
// static/js/48.a4b6eab17051657cdabd.js